export default "__VITE_ASSET__baf976a8__"